export default [
    {
        path: '/guide/capsules-video-presentation',
        name: 'guide-video-presentation',
        component: () => import('@/views/guide/VideoPresentationView.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/guide/capsules-video-evaluation',
        name: 'guide-video-evaluation',
        component: () => import('@/views/guide/VideoEvaluationView.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/guide/capsules-video-connexion',
        name: 'guide-video-connexion',
        component: () => import('@/views/guide/VideoConnexionView.vue'),
        meta: { requiresAuth: true },

    },

]